import { makeId } from '@/shared/lib';
import { useRef } from 'react';

/**
 * Supplies a stable random suffix used to build unique DOM ids for the studies table action column. Holds a nine-character random identifier in a ref so it survives re-renders.
 *
 * @returns Object exposing the ref that carries the generated id.
 */
export const useColumnWithActionFormatter = () => {
  const idRef = useRef(makeId(9));

  return { idRef };
};
